<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <StaticInfoForm @submit-requested="submitRequested"></StaticInfoForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import StaticInfoForm from '@/views/StaticInfos/StaticInfoForm.vue'

  export default {
  components: { StaticInfoForm },
  methods: {
    ...mapActions('staticInfos', ['postStaticInfo']),
    submitRequested (input) {
      this.postStaticInfo(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 